// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"75bf388e","977":"db6b3e2a"}[chunkId] + ".chunk.js";
};